export const environment = {
  production: true,
  api_url: 'https://api.aly.team/api',
  applicationServerPublicKey: 'BPoTV1b0BhnFfNr6qvYzPiSFGLeuqAPuPJQQ0TCHANWTD3kDvmTvEs8_GdhC9n0kXtDxENV16SluO0tq9t3lW5Q',
  admin_TimeZone: 'America/Chicago',
  signalR_url: "https://funcappconnectapptosignalr-prod.azurewebsites.net/api/negotiate?userEmail=${userEmail}",
};